<template>
  <div class="Code">
    <van-nav-bar title="我的二维码" fixed bord>
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="mycode">
      <div class="info">
        <van-image round :src="attach_url+userinfo.u_headportrait" class="err-image-header" />
        <div class="name">
          <div>{{userinfo.u_nickname}}</div>
          <div>{{'账号：'+userinfo.u_login_id}}</div>
        </div>
      </div>
      <div class="codeimg">
			<vue-qr :text="registUrl+u_code" :size="180" ref="Qrcode"></vue-qr>
      </div>
      <div class="notice">扫描二维码，加我为好友</div>
    </div>
    <van-button
      class="btn"
      v-clipboard:copy="registUrl+u_code"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >复制链接</van-button>
  </div>
</template>
<script type="text/javascript">
import vueQr from "vue-qr";
export default {
	name: "Code",
	components: {
		vueQr
	},
	data() {
		return {
			actionName: "",
			active: "",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			userinfo: [],
			url: "",
			u_code: "",
			registUrl: this.Conf.clientOrigin+'/Regist?code=',
			attach_url: this.Conf.serverPre
		};
	},
	created() {
		this.getStateConfigs();
		this.loadData();
		if (confs.regist_url) {
			this.registUrl = confs.regist_url.values;
		}
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		onClickLeft() {
			this.$router.go(-1);
		},
		getAction() {
			var params = this.$route.query;
			this.actionName = params.actionName;
			this.active = params.active;
		},
		loadData() {
			var params = {
				u_id: this.u_id,
				token: this.token
			};
			var url = this.Conf.serverUrl + "User/getUserInfoById" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.userinfo = response.data.result;
				this.u_code = this.userinfo.u_code;
			})
			.catch(error => {});
		},
		// 复制成功
		onCopy(e) {
		  this.$toast("链接复制成功,去分享吧！");
		},
		// 复制失败
		onError(e) {
		  this.$toast("复制失败,可以找客服哟！");
		}
	},
	mounted() {
		this.getAction();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Message/Code.vue